import { Service } from '@/tools'
export class DeliveryTaskFormService<T extends TStock.deliveryTaskForm> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(
    url: `${P}/${keyof TStock.deliveryTaskForm}`,
    data?: TCommon.Json,
    toast?: string
  ) {
    return this.post(url, data, toast)
  }

  /**
   * 功能：分页查询发货任务单列表
   * /api/stock/deliveryTaskForm/v1/queryDeliveryTaskFormPageList
   */
  queryDeliveryTaskFormPageList = (data: T['ApiQueryDeliveryTaskFormPageList']['req']): Promise<T['ApiQueryDeliveryTaskFormPageList']['res']> =>
    this.post2('v1/ApiQueryDeliveryTaskFormPageList', data)

  /**
   * 功能：分发分页列表查询
   * /api/stock/deliveryTaskForm/v1/queryDeliveryDistributePage
   */
  queryDeliveryDistributePage = (data: T['ApiQueryDeliveryDistributePage']['req']): Promise<T['ApiQueryDeliveryDistributePage']['res']> =>
    this.post2('v1/ApiQueryDeliveryDistributePage', data)

  /**
   * 功能：按商品分发查询
   * /api/stock/deliveryTaskForm/v1/queryDistributeBySku
   */
  queryDistributeBySku = (data: T['ApiQueryDistributeBySku']['req']): Promise<T['ApiQueryDistributeBySku']['res']> =>
    this.post2('v1/ApiQueryDistributeBySku', data)

  /**
   * 功能：按商品分发确认
   * /api/stock/deliveryTaskForm/v1/confimBatchDistributeBySku
   */
  confimBatchDistributeBySku = (data: T['ApiConfimBatchDistributeBySku']['req']): Promise<T['ApiConfimBatchDistributeBySku']['res']> =>
    this.post2('v1/ApiConfimBatchDistributeBySku', data, '操作成功')

  /**
   * 功能：查询打包要求
   * /api/stock/deliveryTaskForm/v1/queryDeliveryTaskFormPackageAdvice
   */
  queryDeliveryTaskFormPackageAdvice = (
    data: T['ApiQueryDeliveryTaskFormPackageAdvice']['req']
  ): Promise<T['ApiQueryDeliveryTaskFormPackageAdvice']['res']> => this.post2('v1/ApiQueryDeliveryTaskFormPackageAdvice', data)

  /**
   * 功能：查询打包明细信息
   * /api/stock/deliveryTaskForm/v1/queryDeliveryTaskFormPackageInfo
   */
  queryDeliveryTaskFormPackageInfo = (
    data: T['ApiQueryDeliveryTaskFormPackageInfo']['req']
  ): Promise<T['ApiQueryDeliveryTaskFormPackageInfo']['res']> => this.post2('v1/ApiQueryDeliveryTaskFormPackageInfo', data)

  /**
   * 功能：查询任务单下sku
   * /api/stock/deliveryTaskForm/v1/queryDeliveryTaskFormPackageSku
   */
  queryDeliveryTaskFormPackageSku = (data: T['ApiQueryDeliveryTaskFormPackageSku']['req']): Promise<T['ApiQueryDeliveryTaskFormPackageSku']['res']> =>
    this.post2('v1/ApiQueryDeliveryTaskFormPackageSku', data)

  /**
   * 功能：录入打包信息
   * /api/stock/deliveryTaskForm/v1/addDeliveryTaskFormPackageInfo
   */
  addDeliveryTaskFormPackageInfo = (data: T['ApiAddDeliveryTaskFormPackageInfo']['req']): Promise<T['ApiAddDeliveryTaskFormPackageInfo']['res']> =>
    this.post2('v1/ApiAddDeliveryTaskFormPackageInfo', data)

  /**
   * 功能：发货任务单详情
   * /api/stock/deliveryTaskForm/v1/queryDeliveryTaskFormDetail
   */
  queryDeliveryTaskFormDetail = (data: T['ApiQueryDeliveryTaskFormDetail']['req']): Promise<T['ApiQueryDeliveryTaskFormDetail']['res']> =>
    this.post2('v1/ApiQueryDeliveryTaskFormDetail', data)

  /**
   * 功能：提总根据发货任务单集合汇总sku列表
   * /api/stock/deliveryTaskForm/v1/deliveryTaskFormGather
   */
  deliveryTaskFormGather = (data: T['ApiDeliveryTaskFormGather']['req']): Promise<T['ApiDeliveryTaskFormGather']['res']> =>
    this.post2('v1/ApiDeliveryTaskFormGather', data)

  /**
   * 功能：发货任务单配发下架
   * /api/stock/deliveryTaskForm/v1/deliveryDownRack
   */
  deliveryDownRack = (data: T['ApiDeliveryDownRack']['req']): Promise<T['ApiDeliveryDownRack']['res']> =>
    this.post2('v1/ApiDeliveryDownRack', data, '操作成功')

  /**
   * 功能：查询物流明细信息
   * /api/stock/deliveryTaskForm/v1/queryDeliveryTaskFormLogisticsInfo
   */
  queryDeliveryTaskFormLogisticsInfo = (
    data: T['ApiQueryDeliveryTaskFormLogisticsInfo']['req']
  ): Promise<T['ApiQueryDeliveryTaskFormLogisticsInfo']['res']> => this.post2('v1/ApiQueryDeliveryTaskFormLogisticsInfo', data)

  /**
   * 功能：录入发货物流信息
   * /api/stock/deliveryTaskForm/v1/addDeliveryTaskFormSelfLogisticsInfo
   */
  addDeliveryTaskFormSelfLogisticsInfo = (
    data: T['ApiAddDeliveryTaskFormSelfLogisticsInfo']['req']
  ): Promise<T['ApiAddDeliveryTaskFormSelfLogisticsInfo']['res']> => this.post2('v1/ApiAddDeliveryTaskFormSelfLogisticsInfo', data, '操作成功')

  /**
   * 功能：查询客户确认收货
   * /api/stock/deliveryTaskForm/v1/queryDeliveryCustomerConfirmDetail
   */
  queryDeliveryCustomerConfirmDetail = (
    data: T['ApiQueryDeliveryCustomerConfirmDetail']['req']
  ): Promise<T['ApiQueryDeliveryCustomerConfirmDetail']['res']> => this.post2('v1/ApiQueryDeliveryCustomerConfirmDetail', data)

  /**
   * 功能：客户确认收货
   * /api/stock/deliveryTaskForm/v1/deliveryConfirmCoustomerReceipt
   */
  deliveryConfirmCoustomerReceipt = (data: T['ApiDeliveryConfirmCoustomerReceipt']['req']): Promise<T['ApiDeliveryConfirmCoustomerReceipt']['res']> =>
    this.post2('v1/ApiDeliveryConfirmCoustomerReceipt', data, '操作成功')
  /**
   * 功能：关闭发货任务单
   * /api/stock/deliveryTaskForm/v1/closeDeliveryTaskForm
   */
  closeDeliveryTaskForm = (data: T['ApiCloseDeliveryTaskForm']['req']): Promise<T['ApiCloseDeliveryTaskForm']['res']> =>
    this.post2('v1/ApiCloseDeliveryTaskForm', data, '操作成功')
}
